import React, { useState } from 'react'

import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Stack from 'react-bootstrap/Stack'

import { Spinner } from '../../LoadingContainer/Spinner'

export default function TerminalPaymentWaiting({
  title = 'Present card on terminal',
  description = 'Ask the customer to tap or insert their card.',
  statusLabel,
  onCancel,
}) {
  const [cancelling, setCancelling] = useState(false)

  const handleCancel = async () => {
    if (cancelling || !onCancel) return
    setCancelling(true)
    try {
      await onCancel()
    } finally {
      setCancelling(false)
    }
  }

  return (
    <Modal.Body className="modal--lg">
      <Stack
        gap={4}
        className="text-center img--round-before img--round-before-lg background-icon-lg background-icon-primary background-icon-card"
      >
        <h4 className="modal-body-heading-title mb-0">{title}</h4>
        <p className="pt-0 mt-1 mb-0">{description}</p>
        {statusLabel ? (
          <p className="pt-0 mt-0 text-muted small mb-0">{statusLabel}</p>
        ) : null}
      </Stack>
      <Stack className="btn-group-flex">
        <Button
          size="lg"
          variant="outline-secondary"
          onClick={handleCancel}
          disabled={cancelling}
        >
          {cancelling ? <Spinner /> : 'Cancel payment'}
        </Button>
      </Stack>
    </Modal.Body>
  )
}
